import { useCustomerEnvironmentContext } from "./useCustomerEnvironmentContext";
import { ActionGroup, SelectableAction } from "shared-ts-ui-action";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";

export const useCustomerEnvironmentActionGroup = () => {
  const { t: t_firefly_shared_domain } = useTranslation(
    "firefly-shared-ts-customer-environment"
  );
  const { environmentId, environmentList, setEnvironment } =
    useCustomerEnvironmentContext();

  return useMemo(() => {
    return environmentList.length > 1
      ? ({
          type: "ActionGroup",
          name: t_firefly_shared_domain("Environment"),
          preferences: {
            displayInline: false,
            hideGroupNodeSelected: false,
          },
          disabled: environmentList.length === 1,
          items: environmentList.map((env) => {
            return {
              type: "Action",
              selectable: true,
              name: env.name,
              reference: env.id,
              onExecute: () => {
                setEnvironment(env.id);
              },
              selected: env.id === environmentId,
            } as SelectableAction;
          }),
        } as ActionGroup)
      : undefined;
  }, [environmentId, environmentList, setEnvironment, t_firefly_shared_domain]);
};
